module.exports = __webpack_public_path__ + "static/media/run.4d1d1613.svg";